var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "user"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('fieldset', [_c('div', {
    staticClass: "card-body1"
  }, [_c('legend', [_vm._v("Varify AWB and Flyer")]), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.formLoading
    },
    on: {
      "update:active": function($event) {
        _vm.formLoading = $event
      }
    }
  }), _vm._v(" "), _c('form', {
    attrs: {
      "method": "post",
      "data-vv-scope": "form-1"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitForm('form-1')
      }
    }
  }, [_c('div', {
    staticClass: "form group-row"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Scan Shipment barcode :")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "right": _vm.srLoader,
      "left": "<i class='fa fa-barcode'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipmentBarcode),
      expression: "shipmentBarcode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|alpha_num'),
      expression: "'required|alpha_num'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('form-1.shipmentBarcode')
    },
    attrs: {
      "type": "text",
      "id": "shipmentBarcode",
      "placeholder": "Scan Shipment Barcode",
      "name": "shipmentBarcode",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.shipmentBarcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shipmentBarcode = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.shipmentBarcode')),
      expression: "errors.has('form-1.shipmentBarcode')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('form-1.shipmentBarcode')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-10 mt-4"
  }, [_c('dummy-input', {
    ref: "dummyShipInputBox",
    attrs: {
      "isDummyInput": _vm.isShowDummyInput,
      "duration": _vm.dummyInputTimeout,
      "styleData": _vm.styleData
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Scan Flyer Barcode:")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-barcode'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.flyerBarcode),
      expression: "flyerBarcode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|alpha_num'),
      expression: "'required|alpha_num'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('form-1.flyerBarcode')
    },
    attrs: {
      "type": "text",
      "placeholder": "Scan Flyer Barcode",
      "name": "flyerBarcode",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.flyerBarcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.flyerBarcode = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.flyerBarcode')),
      expression: "errors.has('form-1.flyerBarcode')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('form-1.flyerBarcode')))])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-start",
    staticStyle: {
      "margin-left": "0"
    }
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('b-input-group', [_c('button', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Verify")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('b-input-group', [_c('button', {
    staticClass: "btn btn-danger btn-block",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v(" Reset")])])], 1)], 1)])])], 1)])])], 1)])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b698c14","hasScoped":true}!./src/views/components/RVPVerifyAwbAndFlyer/RVPVerifyAwbAndFlyer.component.html
// module id = 1606
// module chunks = 1